import { Group, Text } from "@mantine/core";
import Logo from "../../../../../../../components/logos/tiber/Logo";
import { useNotePageStyles } from "./NotePage";

export default function NoteBranding({
  subjectColorIndex,
}: {
  subjectColorIndex: string;
}) {
  const { classes } = useNotePageStyles({ subjectColorIndex });
  return (
    <Group className={classes.branding} justify="center">
      <Logo size={20} />
      <Text size="sm" c="lightblue">
        tibertutor.com
      </Text>
    </Group>
  );
}
